module.exports = __webpack_public_path__ + "img/bilingual.7a7d7d47.svg";